import { useGovernance, DataContainer } from '@estream/sdk-browser/react';
import { ProposalStatus } from '@estream/sdk-browser';
import './Governance.css';

export default function Governance() {
  const result = useGovernance();
  
  return (
    <div className="governance-page animate-in">
      <DataContainer {...result}>
        {(gov) => (
          <>
            {/* Pending Proposals */}
            <section className="card">
              <div className="card-header">
                <h2 className="card-title">Pending Proposals</h2>
                {(gov.pendingProposals?.length || 0) > 0 && (
                  <span className="badge badge-warning">
                    {gov.pendingProposals?.length} awaiting approval
                  </span>
                )}
              </div>
              
              {(gov.pendingProposals?.length || 0) === 0 ? (
                <div className="empty-state">
                  <span className="empty-icon">✅</span>
                  <p>No pending proposals</p>
                </div>
              ) : (
                <div className="proposal-list">
                  {gov.pendingProposals?.map((proposal, i) => (
                    <ProposalCard key={i} proposal={proposal} />
                  ))}
                </div>
              )}
            </section>
            
            {/* Recent Proposals */}
            <section className="card">
              <div className="card-header">
                <h2 className="card-title">Recent Activity</h2>
              </div>
              
              {(gov.recentExecuted?.length || 0) === 0 ? (
                <div className="empty-state">
                  <span className="empty-icon">📋</span>
                  <p>No recent proposals</p>
                </div>
              ) : (
                <table className="table">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Status</th>
                      <th>Signatures</th>
                      <th>Completed</th>
                    </tr>
                  </thead>
                  <tbody>
                    {gov.recentExecuted?.map((proposal, i) => (
                      <tr key={i}>
                        <td>
                          <span className="badge badge-primary">
                            {proposal.proposalType || 'Unknown'}
                          </span>
                        </td>
                        <td>
                          <span className={`badge ${proposal.status === ProposalStatus.Approved ? 'badge-success' : 'badge-error'}`}>
                            {proposal.status || 'Unknown'}
                          </span>
                        </td>
                        <td>
                          {proposal.signatureCount || 0} / 
                          {proposal.threshold || 2}
                        </td>
                        <td>Recently</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </section>
          </>
        )}
      </DataContainer>
    </div>
  );
}

interface ProposalProps {
  proposal: unknown;
}

function ProposalCard({ proposal }: ProposalProps) {
  const p = proposal as {
    id?: string;
    proposalType?: string;
    title?: string;
    signaturesReceived?: number;
    signaturesRequired?: number;
    expiresAt?: number;
  };
  
  return (
    <div className="proposal-card">
      <div className="proposal-header">
        <span className="badge badge-warning">{p.proposalType || 'Unknown'}</span>
        <span className="proposal-id">{p.id?.slice(0, 12)}...</span>
      </div>
      
      <h3 className="proposal-title">{p.title || 'Untitled Proposal'}</h3>
      
      <div className="proposal-meta">
        <span className="sig-count">
          {p.signaturesReceived || 0} of {p.signaturesRequired || 2} signatures
        </span>
        {p.expiresAt && (
          <span className="expires">
            Expires in {Math.max(0, Math.floor((p.expiresAt - Date.now()) / 60000))}m
          </span>
        )}
      </div>
      
      <div className="proposal-actions">
        <button className="btn btn-primary">Approve with Spark</button>
        <button className="btn btn-secondary">View Details</button>
      </div>
    </div>
  );
}
